import { Group, Title, Button } from '@mantine/core';
import { AiOutlinePlus } from 'react-icons/ai';

interface SelectionPageHeaderProps {
    onAddPaymentMethod: () => void;
}

export const SelectionPageHeader = ({ onAddPaymentMethod }: SelectionPageHeaderProps) => {
    return (
        <Group justify="space-between" p="md">
            <Title order={2}>Select Payment Method</Title>
            <Button
                leftSection={<AiOutlinePlus size={16} />}
                onClick={onAddPaymentMethod}
                variant="light"
            >
                Add Payment Method
            </Button>
        </Group>
    );
};
